'use es6';

import Raven from 'Raven';
import { sendRequestProductActivationNotification } from '../common/api/requestNotificationsApi';
import { tracker } from '../common/eventTracking/tracker';
import wrapWithErrorMonitoring from '../common/reliability/wrapWithErrorMonitoring';
export var requestProductActivation = wrapWithErrorMonitoring('requestProductActivation', function (_ref) {
  var merchandiseId = _ref.merchandiseId;
  return sendRequestProductActivationNotification(merchandiseId).then(function () {
    tracker.track('requestUpgradeInteraction', {
      action: 'request product activation notification succeeded',
      merchandiseId: merchandiseId
    });
  }).catch(function (e) {
    tracker.track('requestUpgradeInteraction', {
      action: 'request product activation notification failed',
      merchandiseId: merchandiseId
    });
    Raven.captureMessage('Request product activation notification failed', {
      extra: {
        error: e
      }
    });
  });
});